import * as api from '../api/index'

export const toggleNotificationsModal = () => {
    return { type: 'TOGGLE_NOTIFICATIONS_MODAL' }
}